import { StateChangeCell } from "@similarweb/pro-logic-components";

import { TrafficShare } from "app/components/React/Table/cells";
import { getIndexCellPropsForTableV2 } from "app/components/React/Table/cells/IndexCell";
import { PercentPointCell } from "app/components/React/Table/cells/PercentPointCell";
import { decodeSite } from "app/components/React/Table/Utils/urlCellsUtils";
import { translate } from "app/filters/i18nFilter";
import { UNDEFINED_SIGN } from "app/common/campaigns/KeywordsCampaginKeywordsTableConsts";

import { CellSiteWithDropdown } from "../CellSiteDropdown/CellSiteDropdown";

const COLUMN_WIDTHS = {
    INDEX: 70,
    FOLDER: 500,
    SHARE: 390,
    CHANGE: 144,
} as const;

const getSortOrder = (sortConfig: { columnKey: string; order: "ascend" | "descend" }, columnKey: string) =>
    sortConfig.columnKey === columnKey ? sortConfig.order : null;

const renderChangeCell = (record) => {
    const { lastMonthShare, prevMonthShare } = record;

    if (lastMonthShare === undefined) {
        return <StateChangeCell value={{ changeState: "nodata" }} />;
    }

    if (prevMonthShare === undefined) {
        return <StateChangeCell value={{ changeState: "new" }} />;
    }

    const calculatedChange = lastMonthShare - prevMonthShare;
    return (
        <PercentPointCell
            value={calculatedChange}
            row={record}
        />
    );
};

export const FoldersTableColumns = {
    getColumns: (
        totalCount: number,
        currentPage: number = 1,
        pageSize: number = 100,
        sortConfig: { columnKey: string; order: "ascend" | "descend" },
    ) => {
        const folderTitle = `${translate("analysis.content.pop.folders.table.columns.folder.title")} (${totalCount})`;

        return [
            {
                ...getIndexCellPropsForTableV2<{ parent?: unknown }>(
                    currentPage,
                    pageSize,
                    (record) => !record?.parent,
                ),
                width: COLUMN_WIDTHS.INDEX,
            },
            {
                key: "folder",
                dataIndex: "folder",
                title: folderTitle,
                width: COLUMN_WIDTHS.FOLDER,
                sorter: true,
                sortOrder: getSortOrder(sortConfig, "folder"),
                tooltipTitle: translate("analysis.content.pop.folders.table.columns.folder.title"),
                tooltipSubtitle: translate("analysis.common.content.pop.folders.tooltip"),
                render: (value, record) => {
                    const isFirstParent = !record.parent;
                    const displayText = isFirstParent ? value : record.specificFolder || value;
                    const displayTextAsString = typeof displayText === "string" ? displayText : "";

                    return (
                        <CellSiteWithDropdown
                            folderText={decodeSite(displayTextAsString)}
                            fullPathFolder={value}
                        />
                    );
                },
            },
            {
                key: "share",
                dataIndex: "share",
                title: translate("analysis.content.pop.folders.table.columns.share.title"),
                width: COLUMN_WIDTHS.SHARE,
                sorter: true,
                sortOrder: getSortOrder(sortConfig, "share"),
                tooltipTitle: translate("analysis.content.pop.folders.table.columns.share.title"),
                tooltipSubtitle: translate("analysis.content.pop.folders.table.columns.share.title.tooltip"),
                render: (value, record) => {
                    if (value === null || value === undefined) {
                        return UNDEFINED_SIGN;
                    }
                    return (
                        <div style={{ width: "100%" }}>
                            <TrafficShare
                                value={value}
                                row={record}
                            />
                        </div>
                    );
                },
            },
            {
                key: "change",
                dataIndex: "change",
                title: translate("global.change.mom"),
                width: COLUMN_WIDTHS.CHANGE,
                align: "right" as const,
                tooltipTitle: translate("global.change.mom"),
                tooltipSubtitle: translate("analysis.content.pop.pages.table.columns.change.title.tooltip"),
                render: (_value, record) => renderChangeCell(record),
            },
        ];
    },
};
